<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <input
      :class="b('field')"
      placeholder="--"
      type="number"
      :value="value"
      @input="handleInput"
    />

    <p :class="b('description')">
      {{ description }}
    </p>
  </div>
</template>
